module.exports = __webpack_public_path__ + "static/img/y1.df41e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/y1.png
// module id = hfih
// module chunks = 1